import { Col, Form } from "react-bootstrap";
// import SourceEditing from "@ckeditor/ckeditor5-source-editing/src/sourceediting";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import PropTypes from 'prop-types';

/**
 * این کامپوننت برای ویرایش گر ها است
 */
//////////////////////////////////
export default function InputEditor({ label, name, handelValue, defaultValue }) {

    const handelonChange = (event, editor) => {
        const data = editor.getData();
        handelValue(name, data)
        // //console.log({ data });
    }
    

    return (
        <Form.Row>
            <Col>
                <Form.Group>
                    {label ? <Form.Label>{label}</Form.Label> : null}
                   

                    <CKEditor
                        editor={ClassicEditor}
                        onChange={handelonChange}
                        data={defaultValue !== undefined && defaultValue !== null ? defaultValue : {}}
                        config={{
                            language: {
                                ui: 'ar',
                                content: 'ar'
                            },
                            // plugins: [ Alignment],
                            toolbar: {
                              alignment: {
           options: [
                { name: 'left', className: 'my-align-left' },
                { name: 'right', className: 'my-align-right' }
            ]
        },
            //                 },
                                items: [
                                    'heading', '|',
                                    'alignment', '|','sourceEditing',
                                    'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
                                    'link', '|',
                                    'bulletedList', 'numberedList', 'todoList', '-',
                                    'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor', '|',
                                    'code', 'codeBlock', '|',
                                    'insertTable', '|',
                                    'outdent', 'indent', '|',
                                    'imageUpload', 'blockQuote', '|',
                                    'undo', 'redo'
                                ]
                            },
                            heading: {
                                options: [
                                    { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                                    { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                                    { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                                    { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                                    { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                                    { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                                    { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' },
                                ]
                            },
                           

                        }}

                    />
                </Form.Group>
            </Col>
        </Form.Row>
    )
}
InputEditor.propTypes = {
    /**لیبل اینپوت است */
    label: PropTypes.string,
    /**برای ارسال مقدار اولیه برای اینپوت است */
    defaultValue: PropTypes.string,
    /** مقدار هلدر اینپوت است */
    Placeholder: PropTypes.string,
    /** نام اینپوت است */
    name: PropTypes.string,
    /** ارسال مقدار اینپوت به بالا است */
    handelValue: PropTypes.func
};